document.addEventListener('DOMContentLoaded', function () {
  const triggers = [
    document.getElementById('country-selector-trigger'),
    document.getElementById('country-selector-trigger-mobile')
  ];

  const popup = document.getElementById('language-popup');
  const overlay = document.getElementById('overlay');

  // Step 1 container (top-level list)
  const twoStepContainer = document.getElementById('two-step-language-list-container');

  // Step 2 containers
  const euContainers = document.querySelectorAll('.eu-language-link-container');
  const usContainers = document.querySelectorAll('.us-language-link-container');

  // Triggers for switching steps
  const euLink = document.getElementById('eu-language-link');
  const usLink = document.getElementById('us-language-link');

  // --- preserve current path/query/hash across language links (handles /es, /de, etc.) ---
  function preservePathOnLanguageLinks() {
    var path = window.location.pathname;
    if (path.startsWith('/cart') || path.startsWith('/checkout')) return;
    if (!popup) return;

    var links = popup.querySelectorAll('a.language-link[href]');
    if (!links.length) return;

    var current = new URL(window.location.href);
    var preservePath = current.pathname;
    var preserveSearch = current.search;
    var preserveHash = current.hash;

    links.forEach(function (a) {
      if (!a.dataset.originalHref) {
        a.dataset.originalHref = a.getAttribute('href') || '';
      }
    });

    var localeRoots = new Set();

    links.forEach(function (a) {
      var href = a.dataset.originalHref;
      if (!href) return;

      try {
        var u = new URL(href, window.location.origin);
        var segs = u.pathname.replace(/^\/+|\/+$/g, '').split('/');

        if (segs[0]) {
          var looksLikeLocale = /^[a-z]{2}(-[a-z]{2})?$/i.test(segs[0]) && segs.length === 1;
          if (looksLikeLocale) localeRoots.add('/' + segs[0]);
        }
      } catch (e) {}
    });

    function stripLeadingLocale(p) {
      var cleaned = p || '/';
      var segs = cleaned.replace(/^\/+|\/+$/g, '').split('/');

      if (!segs[0]) return cleaned;

      var first = '/' + segs[0];

      if (localeRoots.has(first)) {
        segs.shift();
        return '/' + segs.join('/');
      }

      if (/^[a-z]{2}(-[a-z]{2})?$/i.test(segs[0])) {
        segs.shift();
        return '/' + segs.join('/');
      }

      return cleaned;
    }

    links.forEach(function (a) {
      var baseHref = a.dataset.originalHref;
      if (!baseHref) return;

      try {
        var target = new URL(baseHref, window.location.origin);

        var targetSegs = target.pathname.replace(/^\/+|\/+$/g, '').split('/');
        var isTrueRoot = target.pathname === '/' || target.pathname === '';
        var isLocaleRoot = targetSegs.length === 1 && /^[a-z]{2}(-[a-z]{2})?$/i.test(targetSegs[0]);

        if (isTrueRoot || isLocaleRoot) {
          var basePath = stripLeadingLocale(preservePath);

          var head = target.pathname.replace(/\/+$/, '');
          var tail = basePath === '/' ? '/' : '/' + basePath.replace(/^\/+/, '');
          var joined = (head + tail).replace(/\/{2,}/g, '/');

          target.pathname = joined;
        }

        target.search = preserveSearch;
        target.hash = preserveHash;

        a.setAttribute('href', target.toString());
      } catch (e) {
        console.warn('[Language Switcher] Could not rewrite link:', baseHref, e);
      }
    });
  }
  // --- end preserve routine ---

  // Run once on load
  preservePathOnLanguageLinks();

  // Open/close popup
  triggers.forEach(function (trigger) {
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      if (!popup || !overlay) return;

      popup.classList.toggle('active');
      overlay.classList.toggle('active');
      document.body.style.overflow = popup.classList.contains('active') ? 'hidden' : 'auto';

      if (popup.classList.contains('active')) preservePathOnLanguageLinks();

      resetLanguageLinks();
    });
  });

  if (overlay) {
    overlay.addEventListener('click', function () {
      if (!popup) return;

      popup.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = 'auto';

      resetLanguageLinks();
    });
  }

  // Click "Muc-Off EU" → show EU language list
  if (euLink && euContainers.length && twoStepContainer) {
    euLink.addEventListener('click', function () {
      twoStepContainer.classList.add('eu-hidden');
      twoStepContainer.classList.remove('eu-visible');

      euContainers.forEach(function (container) {
        container.classList.remove('eu-hidden');
        container.classList.add('eu-visible');
      });

      preservePathOnLanguageLinks();
    });
  }

  // Click "Muc-Off US" → show US language list
  if (usLink && usContainers.length && twoStepContainer) {
    usLink.addEventListener('click', function () {
      twoStepContainer.classList.add('eu-hidden');
      twoStepContainer.classList.remove('eu-visible');

      usContainers.forEach(function (container) {
        container.classList.remove('eu-hidden');
        container.classList.add('eu-visible');
      });

      preservePathOnLanguageLinks();
    });
  }

  // Reset all containers when closing the popup
  function resetLanguageLinks() {
    setTimeout(function () {
      if (twoStepContainer) {
        twoStepContainer.classList.remove('eu-hidden');
        twoStepContainer.classList.add('eu-visible');
      }

      euContainers.forEach(function (container) {
        container.classList.remove('eu-visible');
        container.classList.add('eu-hidden');
      });

      usContainers.forEach(function (container) {
        container.classList.remove('eu-visible');
        container.classList.add('eu-hidden');
      });
    }, 300);
  }
});